import React, { FC } from 'react';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';
import AddCommentIcon from '@material-ui/icons/AddComment';

import { Events } from 'analytics';
import { useContent } from 'hooks';
import { ReactionType, useAddReactionAnalyticsMutation } from 'api';

const useStyles = makeStyles(theme => ({
  root: {
    padding: `${theme.spacing(0)}px ${theme.spacing(1)}px`,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const MessagingButton: FC = () => {
  const classes = useStyles();
  const content = useContent();
  const navigate = useNavigate();
  const { content_id } = content;

  const { mutate: addReactionAnalytics } = useAddReactionAnalyticsMutation();

  function onClickButton() {
    handleOpen();

    addReactionAnalytics({
      content_id,
      reaction_type: ReactionType.Comment,
    });
  }

  function handleOpen() {
    window?.analytics?.track(Events.ClickPostDiscussion);
    navigate(`/content/${content.content_id}`);
  }

  return (
    <IconButton className={classes.root} data-testid="post-actions-comment" onClick={onClickButton}>
      <AddCommentIcon />
    </IconButton>
  );
};

export default MessagingButton;
